'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = void 0;
var tslib_1 = require("tslib");
var genericError_js_1 = require("./genericError.js");
/**
 * Ошибка валидации. Должна использоваться, когда аргументы не проходят валидацию.
 *
 * @example
 *
 * function fooHandler(req) {
 *    if (!req.header('X-RealUserId') || !req.header('X-Foo')) {
 *      throw new ValidationError({ message: 'Validation Error!', domain: 'fooHandler', details: {
 *        'X-Foo': req.header('X-Foo'),
 *        'X-RealUserId': req.header('X-RealUserId'),
 *      } });
 *    }
 * }
 *
 * @export
 * @class ValidationError
 * @extends {GenericError}
 */
var ValidationError = /** @class */ (function (_super) {
    tslib_1.__extends(ValidationError, _super);
    function ValidationError(_a) {
        var message = _a.message, domain = _a.domain, details = _a.details;
        var _this = _super.call(this, {
            type: 'ValidationError',
            message: message,
            domain: domain,
            details: details,
        }) || this;
        Object.setPrototypeOf(_this, ValidationError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, ValidationError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return ValidationError;
}(genericError_js_1.GenericError));
exports.ValidationError = ValidationError;
//# sourceMappingURL=validationError.js.map
